import React from "react";
import type { ContentCarouselFullImageSlide } from "@/types/content";
import { responsiveCmsImage } from "@/utils/cmsImage";
import styles from "./ContentCarousel.module.css";

/** The slide's width: the carousel container, 1136px wide in the block grid. */
const SLIDE_SIZES = "(max-width: 1200px) 100vw, 1136px";

interface FullImageSlideProps {
  slide: ContentCarouselFullImageSlide;
  /** Whether to use lazy loading on the image */
  lazy?: boolean;
}

export const FullImageSlide: React.FC<FullImageSlideProps> = ({
  slide,
  lazy = true,
}) => {
  return (
    <div className={styles.fullImageSlide}>
      <img
        {...responsiveCmsImage(
          slide.backgroundImage.url,
          SLIDE_SIZES,
          slide.backgroundImage.width
        )}
        alt={slide.backgroundImage.altText || ""}
        className={styles.fullImageBg}
        loading={lazy ? "lazy" : undefined}
      />
      <div className={styles.fullImageOverlay} aria-hidden="true" />
      <div className={styles.fullImageContent}>
        {slide.heading && (
          <h2 className={styles.fullImageHeading}>{slide.heading}</h2>
        )}
        {slide.subtitle && (
          <p className={styles.fullImageSubtitle}>{slide.subtitle}</p>
        )}
        {slide.ctaButton?.url && (
          <a
            href={slide.ctaButton.url}
            target={slide.ctaButton.target || undefined}
            className={styles.introCtaButton}
          >
            {slide.ctaButton.name}
          </a>
        )}
      </div>
    </div>
  );
};
